const generalNL = {
    "modalConfirm": {
        "button": {
            "cancel": "Annuleren",
            "confirm": "Bevestigen"
        }
    },
    "tableDropdown": {
        "action": "Actie",
        "edit": "Bewerken",
        "delete": "Verwijderen",
        "viewDetails": "Details bekijken",
        "copyMLId": "Kopieer ML ID",
        "viewStats": "Statistieken bekijken"
    },
    "tableModal": {
        "cancel": "Annuleren",
        "confirm": "Bevestigen",
        "edit": "Bewerken"
    },
    "invoiceModal": {
        "button": {
            "cancel": "Annuleren",
            "confirm": "Bevestigen"
        }
    },
    "select": {
        "placeholder": "Selecteren..."
    },
    "asyncDropdown": {
        "placeholder": "Zoeken...",
        "loading": "Laden...",
        "noResults": "Geen opties",
        "blacklisted": "Op de zwarte lijst"
    },
    "table": {
        "noDataAvailable": "Geen gegevens beschikbaar"
    },
    "tableHelper": {
        "loading": "Laden...",
        "error": "Er is een fout opgetreden",
        "noData": "Er zijn geen gegevens beschikbaar"
    },
    "countriesSelect": {
        "placeholder": "Zoek land..."
    },
    "consentModal": {
        "header": "Toestemming Vereist",
        "body": {
            "description": "Beoordeel en accepteer onze nieuwe toestemmingsvoorwaarden om onze diensten te blijven gebruiken.",
            "label": {
                "firstName": "Voornaam",
                "lastName": "Achternaam",
                "email": "E-mail",
                "termsOfUsageAgreement": "Ik ga akkoord met de <1>Gebruiksvoorwaarden</1>",
                "privacyPolicyAgreement": "Ik ga akkoord met het <1>Privacybeleid</1>",
                "cookiePolicyAgreement": "Ik ga akkoord met het <1>Cookiebeleid</1>"
            }
        },
        "button": {
            "submit": "Verzenden"
        }
    },
    "passwordResetModal": {
        "header": "Wijzig Uw Wachtwoord",
        "body": {
            "form": {
                "label": {
                    "currentPassword": "Huidig wachtwoord",
                    "newPassword": "Nieuw wachtwoord",
                    "repeatNewPassword": "Herhaal nieuw wachtwoord"
                },
                "button": {
                    "submit": "Verzenden"
                },
                "message": {
                    "currentPasswordRequired": "Uw oude wachtwoord is vereist",
                    "newPasswordRequired": "Nieuw wachtwoord is vereist",
                    "newPasswordMinLength": "Uw wachtwoord moet minstens 10 tekens lang zijn",
                    "newPasswordDifferentFromOld": "Nieuw wachtwoord moet verschillen van het oude wachtwoord",
                    "newPasswordConfirmation": "Nieuw wachtwoord moet overeenkomen"
                }
            }
        },
        "footer": {
            "note": "<strong>Opmerking: </strong>Het is een tijdje geleden dat u uw wachtwoord heeft bijgewerkt. Voor uw veiligheid, reset uw wachtwoord."
        },
        "message": {
            "success": "Uw wachtwoord is gewijzigd!",
            "error": "Er is iets misgegaan! Vernieuw de pagina en probeer het opnieuw!"
        },
        "modal": {
            "confirm": {
                "header": "Weet u zeker dat u uw wachtwoord wilt wijzigen?",
                "body": "Bevestig alstublieft"
            }
        }
    },
    "qcFeedback": {
        "label": {
            "qcFeedback": "QC Feedback"
        }
    },
    "subUserFilter": {
        "label": {
            "subUser": "Subgebruiker: "
        },
        "placeholder": {
            "subUser": "Selecteer Subgebruiker"
        },
        "button": {
            "reset": "Resetten"
        }
    },
    "footer": {
        "label": {
            "copyright": "Copyright © {{year}}",
            "allRightsReserved": "Alle rechten voorbehouden.",
            "privacyPolicy": "Privacybeleid",
            "termsAndConditions": "Algemene voorwaarden"
        }
    },
    "promoBannerHeader": {
        "exclusiveOfferFor": "Exclusieve Offer voor",
        "off": "OFF",
        "promoCode": "Promo Code",
        "expiresIn": "Verloopt in",
        "clickHereToAvailThisOffer": "Klik hier om deze offerte te gebruiken",
        "availableOnAllSubscriptionPlans": "Beschikbaar op alle abonnementen."
    },
    "promoBanner": {
        "exclusiveOfferFor": "Exclusieve Offer voor",
        "off": "OFF",
        "limitedTimePromoOffer": "Deze tijdelijke Promo Code is exclusief voor u gemaakt. Mis deze kans niet!",
        "promoCode": "Uw Promo Code",
        "expiresIn": "Aanbieding verloopt over",
        "days": "Dagen",
        "hours": "Uren",
        "minutes": "Minuten",
        "seconds": "Seconden",
        "availableOnAllSubscriptionPlans": "Deze exclusieve offerte is beschikbaar op alle abonnementen."
    }
};

export default generalNL;